module.exports = __webpack_public_path__ + "media/images/chevron-up-04ea1bbd591006ea31a09d4cb904e230.svg";